import isURL from 'validator/lib/isURL';

/**
 * Only render a source if is an actual URL
 * @param {String} src src to be rendered in an avatar image
 */
export function renderAvatarUrl (src) {
  if(src && isURL(src)) {
    return src;
  } else {
    return ''
  }
}

/**
 * Show readable date for a timestamp
 * @param {String} timestamp timestamp
 */
export function renderTimestampAsDate (timestamp) {
  if (!timestamp) {
    return '';
  }
  return (new Date(parseInt(timestamp, 10))).toISOString().slice(0, 10);
}



// WEBPACK FOOTER //
// ./src/util/renderHelpers.js